import { apiPath } from 'constants/api';

import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ApiClient } from '@travel/api-client';
import loggerGenerator from '@travel/logger';

import type { DefaultSNSValues } from '../apiTypes';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const fetchDefaultSNSList = createAsyncThunk<
  DefaultSNSValues[],
  void,
  { extra: { apiClient: ApiClient } }
>('sns/default/fetch', async (_, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const data = await apiClient.get(apiPath.snsList.pathname);

    return data;
  } catch (error) {
    logger.error('Error fetching SNS List:', error);
    noticeError('Error fetching SNS List:', error);

    return rejectWithValue(error);
  }
});
